const initialState = {
    loading: false,
    error: null,
    message:null,
    webinarDetails:null,
}

const ContentReducer = (state = initialState, action) => {
    switch(action.type){
        case 'GET_WEBINAR_PAGE_DETAIL_REQUEST':
            return {
                ...state,
                loading:true,
            }
        case 'GET_WEBINAR_PAGE_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                webinarDetails:action.payload,
            }
        case 'GET_WEBINAR_PAGE_DETAIL_FAILURE':
            return {
                ...state,
                error:action.payload,
                loading:false,
            }
        default: return state
    }
}

export default ContentReducer